import { render, staticRenderFns } from "./AdjustmentDetailsStep.vue?vue&type=template&id=ecf4b2a6&scoped=true&"
import script from "./AdjustmentDetailsStep.vue?vue&type=script&lang=js&"
export * from "./AdjustmentDetailsStep.vue?vue&type=script&lang=js&"
import style0 from "./AdjustmentDetailsStep.vue?vue&type=style&index=0&id=ecf4b2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf4b2a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecf4b2a6')) {
      api.createRecord('ecf4b2a6', component.options)
    } else {
      api.reload('ecf4b2a6', component.options)
    }
    module.hot.accept("./AdjustmentDetailsStep.vue?vue&type=template&id=ecf4b2a6&scoped=true&", function () {
      api.rerender('ecf4b2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/InvoiceAdjustmentRule/Modals/steps/AdjustmentDetailsStep.vue"
export default component.exports